// extracted by mini-css-extract-plugin
export default {"mobileModal":"styles_mobileModal__Q-rvg","buttonOverwrite":"styles_buttonOverwrite__SVmF2","fullView":"styles_fullView__yMYzX","shimmer":"styles_shimmer__R8oEd"};